<div
  class="ui segment"
  appMargin
  marginB="3"
  fxLayout="row"
  fxLayoutGap="10px"
  fxLayoutAlign="start stretch"
    [formGroup]="templateForm"
>
  <!-- <div fxFlex="5%">
    <sui-checkbox> </sui-checkbox>
  </div> -->
  <div fxFlex="grow">{{ procurement?.documentTypeName }}</div>
  <div fxFlex="15%">
    <span
      class="ui red label"
      [ngClass]="{ green: procurement.isRequired == true }"
      >{{ procurement?.isRequired }}</span
    >
  </div>
  <!-- <div fxFlex="grow">{{procurement?.description}}</div> -->
  <div fxFlex="20%">{{ procurement?.createdBy | createdBy }}</div>
  <div fxFlex="20%">{{ procurement?.dateCreated | date }}</div>
  <div fxFlex="10%">
    <span
      class="ui red label rounded"
      [ngClass]="{ green: procurement.isActive == true }"
      >{{ procurement?.isActive ? "Active" : "inActive" }}</span
    >
  </div>
  <div fxFlex="10%">
    <sui-checkbox class="toggle" formControlName="isActive"> </sui-checkbox>
  </div>
  <div fxFlex="10%" class="text-right">
    <button
      *isPermitted="{ id: 'DOCUMENT_MANAGEMENT', action: 'edit' }"
      class="ui circular tiny button"
      (click)="onEdit.emit(procurement)"
      suiPopup
      [popupInverted]="true"
      popupPlacement="bottom"
      popupText="Edit"
    >
      <i class="pencil icon"></i>
    </button>
    <button
      *isPermitted="{ id: 'DOCUMENT_MANAGEMENT', action: 'remove' }"
      class="ui circular tiny button"
      (click)="onDelete.emit(procurement)"
      suiPopup
      [popupInverted]="true"
      popupPlacement="bottom"
      popupText="Delete"
    >
      <i class="trash icon"></i>
    </button>
  </div>
</div>
